module.exports = {
      id: "question-usage",
      viewBox: "0 0 29 29",
      url: __webpack_public_path__ + "sprite-61689101322b9172a0a44b724a3b7060.svg#question",
      toString: function () {
        return this.url;
      }
    }